import React, { useMemo } from 'react'

import IconButton from './IconButton'

const ShowPassword = ({ focused, value, showPassword, onTogglePassword }) => {
	// <span className='e-input-group-icon e-icons t-fa fa-bicycle' />
	// <span className='e-input-group-icon e-icons t-fa fa-eye-slash' />
	const button = useMemo(() => ({
		icon: showPassword ? 'eye-slash' : 'eye',
		hidden: !focused,
		handler: onTogglePassword
	}), [focused, showPassword, onTogglePassword])

	return <IconButton button={button} />
}

export default ShowPassword